import React from 'react'

const ArrowRight: React.FC = () => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden>
    <path
      d="M1 5 H 11.5 M 8 1.5 L 12 5 L 8 8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="miter"
      fill="none"
    />
  </svg>
)

/**
 * Pastille circulaire des boutons pill (« cap ») avec rail de deux flèches :
 * au survol du .btn-pill parent, le rail glisse pour un effet de relais.
 * À utiliser en dernier enfant d'un élément portant .btn-pill.
 */
export const PillCap: React.FC = () => (
  <span className="pill-cap" aria-hidden>
    <span className="pill-cap-track">
      <span className="pill-cap-cell">
        <ArrowRight />
      </span>
      <span className="pill-cap-cell">
        <ArrowRight />
      </span>
    </span>
  </span>
)
